export function assertCents(value, label = 'importe') {
    if (typeof value !== 'number' || !Number.isInteger(value) || !Number.isSafeInteger(value)) {
        throw new TypeError(`${label} debe ser un entero de céntimos; recibido ${String(value)}`);
    }
    return value;
}
/** Convierte un texto decimal ("1.234,56", "1234.56", "-12") a céntimos sin pasar por coma flotante. */
export function parseCents(text) {
    const raw = text.trim().replace(/\s|€/g, '');
    if (raw === '')
        throw new TypeError('importe vacío');
    let normalized = raw;
    // Si hay coma y punto, el último separador es el decimal.
    if (raw.includes(',') && raw.includes('.')) {
        const lastComma = raw.lastIndexOf(',');
        const lastDot = raw.lastIndexOf('.');
        normalized = lastComma > lastDot ? raw.replace(/\./g, '').replace(',', '.') : raw.replace(/,/g, '');
    }
    else if (raw.includes(',')) {
        normalized = raw.replace(',', '.');
    }
    const match = /^(-)?(\d+)(?:\.(\d{1,2}))?$/.exec(normalized);
    if (!match)
        throw new TypeError(`importe inválido: ${text}`);
    const sign = match[1] ? -1 : 1;
    const whole = Number(match[2]);
    const fraction = (match[3] ?? '').padEnd(2, '0');
    return sign * (whole * 100 + Number(fraction));
}
/** Formatea céntimos como euros con separadores españoles. */
export function formatCents(cents, options = {}) {
    assertCents(cents);
    const negative = cents < 0;
    const abs = Math.abs(cents);
    const whole = Math.floor(abs / 100);
    const fraction = String(abs % 100).padStart(2, '0');
    const wholeText = whole.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const prefix = negative ? '−' : options.sign && cents > 0 ? '+' : '';
    return `${prefix}${wholeText},${fraction}${options.symbol === false ? '' : ' €'}`;
}
/** Suma segura de céntimos. */
export function sumCents(values) {
    let total = 0;
    for (const v of values)
        total += assertCents(v);
    return total;
}
/**
 * Reparte un total en `parts` partes enteras cuya suma es exactamente el total.
 * El resto en céntimos se asigna a las primeras partes (estrategia determinista documentada).
 */
export function splitEven(total, parts) {
    assertCents(total);
    if (!Number.isInteger(parts) || parts <= 0)
        throw new TypeError('número de partes inválido');
    const base = Math.trunc(total / parts);
    let remainder = total - base * parts;
    const result = [];
    for (let i = 0; i < parts; i++) {
        let v = base;
        if (remainder !== 0) {
            const step = remainder > 0 ? 1 : -1;
            v += step;
            remainder -= step;
        }
        result.push(v);
    }
    return result;
}
/** Reparte proporcionalmente con suma exacta; los restos van a las partes con mayor fracción. */
export function splitProportional(total, weights) {
    assertCents(total);
    const sumW = weights.reduce((a, b) => a + b, 0);
    if (weights.length === 0 || sumW <= 0)
        throw new TypeError('pesos inválidos');
    const raw = weights.map((w) => (total * w) / sumW);
    const floors = raw.map((r) => Math.floor(r));
    let remainder = total - floors.reduce((a, b) => a + b, 0);
    const order = raw
        .map((r, i) => ({ i, frac: r - Math.floor(r) }))
        .sort((a, b) => b.frac - a.frac || a.i - b.i);
    const result = [...floors];
    for (const { i } of order) {
        if (remainder <= 0)
            break;
        result[i] = (result[i] ?? 0) + 1;
        remainder -= 1;
    }
    return result;
}
//# sourceMappingURL=money.js.map